<template>
  <div :id="id">
    <div class="tabs">
      <ul>
        <li v-for="(tab, index) in tabs" :key="index" @click="selectTab(index)" :class="{ 'is-active': index === activeTab }">
          <svg v-if="iconHref !== ''"><use :xlink:href="iconHref" /></svg>
          {{ tab.title }}
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <slot :activeTab="activeTab" :tabs="tabs"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    iconHref: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    selectTab(index) {
      this.activeTab = index;
      this.$emit('tabUpdated', index);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    color: $GREY_600;
    font-weight: $BOLD;
    font-size: $DESKTOP_H6_SIZE;

    li {
      float: left;
      padding: 1rem;
      border-radius: 2px 2px 0 0;

      svg {
        width: 1rem;
        height: 1rem;
      }

      &:hover {
        cursor: pointer;
      }

      &.is-active {
        border-top: 2px solid $PRIMARY_GREEN;
        background-color: $WHITE;
        color: $GREY_900;
      }
    }
  }

  &::before {
    @include full-width-banner-insert;
    background-color: $PRIMARY_GREEN_TINT;
  }
}

.tab-content {
  margin-top: rem(50);

  @include mobile {
    margin-top: rem(25);
  }
}
</style>
